<template>
    <div class="flex-page">
      <a-form
        class="form"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-form-item label="微信昵称">
            {{ form.nickname }}
        </a-form-item>
        <a-form-item label="微信头像">
            <img style="width: 80px;" :src="form.headimgurl" alt="">
        </a-form-item>

        <a-form-item label="姓名">
          <a-input
            type="text"
            style="width: 600px"
            v-model="form.name"
          ></a-input>

          <a-checkbox class="label-checkbox" v-model="form.name_show">
            是否显示
          </a-checkbox>
        </a-form-item>

        <a-form-item label="手机号">
          <a-input
            type="text"
            style="width: 600px"
            v-model="form.mobile"
          ></a-input>

          <a-checkbox class="label-checkbox" v-model="form.mobile_show">
            是否显示
          </a-checkbox>
        </a-form-item>

        <a-form-item label="城市">
          <a-input
            type="text"
            style="width: 600px"
            v-model="form.city"
          ></a-input>

          <a-checkbox class="label-checkbox" v-model="form.city_show">
            是否显示
          </a-checkbox>
        </a-form-item>

        <a-form-item label="推荐人">
          <a-select style="width: 600px" v-model="form.tuijianren">
            <a-select-option v-for="(item, key) in tuijianren" :key="key" :value="item">{{ item }}</a-select-option>
          </a-select>

          <a-checkbox class="label-checkbox" v-model="form.tuijianren_show">
            是否显示
          </a-checkbox>
        </a-form-item>

        <a-form-item label="身份">
            <a-checkbox-group style="width: 600px;" v-model="form.shenfen" :options="shenfenList" />

            <a-checkbox class="label-checkbox" v-model="form.shenfen_show">
                是否显示
            </a-checkbox>
        </a-form-item>
       
        <a-form-item label="备注">
          <a-textarea
            style="width: 600px"
            :auto-size="{ minRows: 3, maxRows: 6 }"
            v-model="form.remarks"
          />
          <a-checkbox class="label-checkbox" v-model="form.remarks_show">
            是否显示
          </a-checkbox>
        </a-form-item>

        <a-form-item label="城员等级">
            <a-select style="width: 600px" v-model="form.level">
                <a-select-option v-for="(item, key) in levelList" :key="key" :value="item"> {{ item
                }}</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="城员贡献值">
            <div style="display: flex;">
                <div>{{ form.admin_gongxian }}</div>
                <!-- <div style="margin-left: 20px;">
                    <span>增加贡献值:</span>
                    <a-input-number v-model="form.admin_gongxian_add" :min="0"></a-input-number>
                </div> -->
            </div>
        </a-form-item>
                

      </a-form>
      <div class="buttons">
        <a-button type="primary" @click="sub">更新</a-button>
      </div>
  
    </div>
  </template>
  
  <style lang="scss" scoped>
  .form {
    padding: 40px;
  }
  .label-checkbox{
    margin-left: 20px;
  }
  </style>
  
  <script>
  import moment from 'moment';
  export default {
    data() {
      return {
        formItemLayout: {
          labelCol: {
            span: 3,
          },
          wrapperCol: {
            span: 20,
          },
        },
        form: {},
        tuijianren: [],
        shenfenList: ['贝商', '爱好者', '贝类科研人员'],
        levelList: ['2018城员', '钻石城员', '金城员', '银城员', '游客'],
      };
    },
    async created() {
      const id = this.$route.query.id;

      const res = await this.$axios.get('/shellCity/getTuijianren')
        if(res.tuijianren) {
            this.tuijianren = res.tuijianren.split('|')
        }

      const r = await this.$axios.get("/shellCity/getDetail?id=" + id);
      if (r.status == 1) {
        r.data.shenfen = JSON.parse(r.data.shenfen)
        this.form = r.data;
        // this.form.shenfenArr = JSON.parse(r.data.shenfen)
        this.form.admin_gongxian_add = 0
      }

     
    },
    methods: {
      moment,
      async sub() {
        const r = await this.$axios.post('/shellCity/doUpdate', this.form);
        if(r.status == 1) this.$router.back()
      },
    },
  };
  </script>
